import React from 'react';
import { NestedMenu } from './components';
import { MENU_ITEMS } from './constants';

/**
 * Represents the menu warbox for the dashboard layout.
 *
 * @return {*}
 */
export const MenuWarbox = () => {
    return (
        <div style={{ position: 'relative', padding: 8 }}>
            <NestedMenu items={MENU_ITEMS} />
        </div>
    );
};
